import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faForward, faBackward} from '@fortawesome/free-solid-svg-icons'
import '../Sliders/Sliders.css';
import img1 from '../../../assets/Sliders/1.png';
import img2 from '../../../assets/Sliders/2.png';
import img3 from '../../../assets/Sliders/3.png';
import img4 from '../../../assets/Sliders/4.png';
import img5 from '../../../assets/Sliders/5.png';
import img6 from '../../../assets/Sliders/6.png';
// import img7 from '../../../assets/Sliders/7.jpeg';

import { Link } from 'react-router-dom';


const images = [img1, img2, img3, img4, img5, img6]; 
const overlayTexts = [
  "Descubre nuestra línea Premium",
  "Calidad en cada producto",
  "Ofertas exclusivas para ti",
  "Las Mejores Marcas",
  "Nuestros clásicos favoritos",
  "Productos únicos para ti",
]

const Sliders = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const visibleCount = 2; // Cantidad de imágenes visibles al mismo tiempo

  // Cambiar la imagen cada 2 segundos
  useEffect(() => {
    const intervalId = setInterval(() => {
      handleNext(); // Cambia a la siguiente imagen
    }, 3800); // Cambia la imagen cada(2 segundos)

    return () => clearInterval(intervalId); // Limpiar el intervalo al desmontar el componente
  }, []);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => {
      const nextIndex = prevIndex + 1;
      // Vuelve al inicio si supera el límite
      return nextIndex >= images.length - visibleCount + 1 ? 0 : nextIndex;
    });
  };

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) => {
      const nextIndex = prevIndex - 1;
      // Si es menor a 0, vuelve al último conjunto
      return nextIndex < 0 ? images.length - visibleCount : nextIndex;
    });
  };

  return (
    <div className="slider-container">
      <div className="message">
        <h2 className='title1'>MIRA LO ÚLTIMO</h2>
        <h2 className='title2'>De Nuestros Productos</h2>
        <div className="buttons">
          <button onClick={handlePrevious}> <FontAwesomeIcon icon={faBackward} color='#0f547f' /> </button>
          <button onClick={handleNext}> <FontAwesomeIcon className='icon' icon={faForward} color='#0f547f' /> </button>
        </div>
      </div>
      <div className="image-slider">
        <div className="image-track" style={{ transform: `translateX(-${currentIndex * (106 / visibleCount)}%)` }}>
          {images.map((image, index) => (
            <div className="image-box" key={index}>
              <img src={image} alt={`Image ${index + 1}`} />
              <div className="overlayy">
                <p>{overlayTexts[index]}</p> {/* Texto único basado en el índice */}
                  <button className='bOverlay'> <Link className='bOverlay' to="/productos">Ver Más..</Link></button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Sliders;
